// Copyright (c) 2022 by Move Closer

import { Module, ModuleContent } from '../../contexts'

import { AvailableModuleDriver } from '../allowed'
import { HeadingFormData } from '../partials'

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
export type NewsletterModule = Module<NewsletterModuleContent, AvailableModuleDriver.Newsletter>

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl<
 */
export type NewsletterModuleContent = NewsletterModuleContentData & ModuleContent

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
export interface NewsletterModuleContentData {
  heading?: HeadingFormData
  description?: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum NewsletterFormState {
  Error = 'error',
  Success = 'success'
}
